import type {
  BuilderAgentRequest,
  BuilderChatHistoryResponse,
  BuilderChatTurn,
} from "@/lib/api/databook";
import type { ChatMessage } from "./BuilderStageChat";

export function builderChatMessages(
  history: BuilderChatHistoryResponse | undefined,
): ChatMessage[] {
  const messages = history?.turns.flatMap((turn) => [
    {
      id: `${turn.id}:user`,
      role: "user" as const,
      text: turn.user_message,
    },
    {
      id: `${turn.id}:assistant`,
      role: "assistant" as const,
      text: turn.assistant_message,
    },
  ]) ?? [];
  if (history?.request?.status === "active" || history?.request?.status === "failed") {
    messages.push({
      id: `${history.request.request_id}:user`,
      role: "user",
      text: history.request.user_message,
    });
  }
  return messages;
}

export function updateBuilderChatRequest(
  history: BuilderChatHistoryResponse | undefined,
  request: BuilderAgentRequest | null,
): BuilderChatHistoryResponse | undefined {
  if (!history) return history;
  return { ...history, request };
}

export function appendBuilderChatTurn(
  history: BuilderChatHistoryResponse | undefined,
  turn: BuilderChatTurn,
): BuilderChatHistoryResponse {
  const existingTurns = history?.source_revision_id === turn.source_revision_id
    ? history.turns.filter((existing) => existing.id !== turn.id)
    : [];
  return {
    source_revision_id: turn.source_revision_id,
    turns: [...existingTurns, turn],
    request: null,
  };
}
